import { withRouter, useLocation } from 'react-router-dom'

import MeringoBar from 'components/MeringoBar'
import ManagerNav from 'components/ManagerNav'
import AdminNav from 'components/AdminNav'
import { hasAccessToThis } from 'services/Utilities'
import TopBarModule from './TopBarModule'
import HomeButton from './HomeButton'
import HelpMenu from './HelpMenu'
import UserMenu from './UserMenu'
import AdminMenuMobile from './AdminMenuMobile'
import ManagerMenuMobile from './ManagerMenuMobile'

export const TopBar: React.FC = () => {
  const { pathname } = useLocation()

  return (
    <>
      {hasAccessToThis('isStaff') ? <MeringoBar /> : null}
      <nav className="d-flex justify-content-between navbar merinio-navbar navbar-dark">
        <div className="d-flex align-items-start flex-column">
          <HomeButton />
        </div>

        <div className="d-flex align-items-center flex-column">
          <TopBarModule />
        </div>

        <div className="d-flex align-items-end justify-content-end flex-row">
          <HelpMenu />
          <UserMenu />
        </div>
      </nav>

      {pathname.includes('/admin') ? <AdminMenuMobile /> : null}
      {pathname.includes('/manage') ? <ManagerMenuMobile /> : null}
      {pathname.includes('/manage') ? <ManagerNav pathname={pathname} /> : null}
      {pathname.includes('/admin') ? <AdminNav pathname={pathname} /> : null}
    </>
  )
}

export default withRouter(TopBar)
